import React from "react"

const PostingDialogBody = ({ children }) => (
  <div className="posting-dialog-body">{children}</div>
)

export default PostingDialogBody
